// Capture l'événement d'installation PWA dès le chargement de l'application
let deferredPrompt = null;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener());

export const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

export const isIos = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent);

export const canInstall = () => deferredPrompt !== null;

export const subscribeToInstall = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// Retourne 'accepted', 'dismissed' ou 'unavailable' si le navigateur ne propose pas l'installation directe
export const promptInstall = async () => {
  if (!deferredPrompt) {
    return 'unavailable';
  }
  const promptEvent = deferredPrompt;
  deferredPrompt = null;
  notify();
  promptEvent.prompt();
  const { outcome } = await promptEvent.userChoice;
  return outcome;
};

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    deferredPrompt = event;
    notify();
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    notify();
  });
}
